import moment from "./moment"
import printCart from "./printCart"
import { store, addOfflineOrder } from "@redux"

const createOfflineOrder = (offlineOrderDetails, printCustomerReceipt = false) => {
  const {
    note,
    branchId,
    onlineInitialOrderStatus = "",
    order,
    total = 0,
    shiftId,
    paidDate,
    shiftOrder,
    discounts = [],
    deliveryFees = null,
    orderStatus,
    deliveryType,
    areaName = "",
    deliveryAddress = "",
    deliveryService = "internal",
    addedBySystem,
    addedByFullName
  } = offlineOrderDetails

  const { offlineOrders } = store.getState()

  const offlineOrderId =
    `O-${offlineOrders.length + 1}`

  const offlineOrder = {
    note,
    offlineOrderId,
    code: offlineOrderId,
    total,
    order,
    branchId,
    discounts,
    shiftOrder,
    deliveryFees,
    orderStatus,
    areaName,
    deliveryType,
    deliveryAddress,
    deliveryService,
    addedBySystem,
    shiftId,
    addedByFullName,
    isViewed: false,
    syncedOrderId: "",
    onlineInitialOrderStatus,
    paidDate,
    date: moment().toISOString(),
    accountId: "",
    customerFullName: "",
    customerMobilePhone: ""
  }


  printCustomerReceipt &&
    printCart(offlineOrder)

  store.dispatch(
    addOfflineOrder(offlineOrder)
  )
}

export default createOfflineOrder